import React, { Fragment } from 'react';
import Body2 from '@fuww/library/src/Typography/Body/Body2';
import Headline6
from '@fuww/library/src/Typography/Heading/Headline6';
import { useIntl } from 'react-intl';
import { List } from '@fuww/library/src/List';
import {
  JobsLandingContainer,
  StyledListItem,
  StyledButton,
  JobsLandingTitle,
  Title,
  JobsLandingCategories,
  JobsLandingSidebar,
} from '@fuww/library/src/JobsLanding';
import {
  SideBarAdUnitContainer,
} from '@fuww/library/src/Advertisement';
import { WfbTitle } from '@fuww/library/src/WfbAds';
import WfbAds from '../components/Company/WfbAds';
import { useSiteContext } from '../components/SiteContext';
import Head from '../components/Head';
import messages from '../lib/messages.mjs';
import LinkAndAnchor from '../components/LinkAndAnchor';
import AdUnit from '../lib/adunit';
import withApollo from '../lib/apollo';
import correctLocalizedRoute from '../lib/correctLocalizedRoute';

const categories = [
  'retail',
  'sales',
  'design',
  'product',
  'other',
  'internships',
  'international',
];

const actions = [
  'employers',
  'newsletter',
  'education',
  'careers',
];

const Categories = () => {
  const intl = useIntl();

  return (
    <List className="fu-mdc-list">
      {categories
        .map((category) => (
          <Fragment key={category}>
            <StyledListItem className="fu-list-item-content" showDivider>
              <LinkAndAnchor
                useRouter={false}
                href={intl
                  .formatMessage(messages[`jobsHeading.${category}.href`])}
                hoverUnderline
              >
                <Headline6 tag="h2">
                  {intl.formatMessage(messages[`jobsHeading.${category}`])}
                </Headline6>
                <Body2>
                  {intl.formatMessage(
                    messages[`jobsHeading.${category}.jobTitles`],
                  )}
                  {' '}
                  [...]
                </Body2>
              </LinkAndAnchor>
            </StyledListItem>
          </Fragment>
        ))}
    </List>
  );
};

const Actions = () => {
  const intl = useIntl();
  const { locale } = useSiteContext();

  return (
    <>
      <LinkAndAnchor
        route={`jobs.${locale}`}
        useRouter
        href={intl.formatMessage(messages['searchJobs.href'])}
      >
        <StyledButton role="link">
          {intl.formatMessage(messages.searchJobs)}
        </StyledButton>
      </LinkAndAnchor>
      <LinkAndAnchor
        useRouter={false}
        href={intl.formatMessage(messages['postJob.href'])}
      >
        <StyledButton
          variant="text"
          role="link"
        >
          {intl.formatMessage(messages.postJob)}
        </StyledButton>
      </LinkAndAnchor>
      <List className="fu-mdc-list">
        {actions
          .map((action) => (
            <Fragment key={action}>
              <StyledListItem className="fu-list-item-content" showDivider>
                <LinkAndAnchor
                  useRouter={intl.formatMessage(
                    messages[`jobsAction.${action}.useRouter`],
                  ) === 'true'}
                  route={intl.formatMessage(
                    messages[`jobsAction.${action}.route`],
                  )}
                  href={intl.formatMessage(
                    messages[`jobsAction.${action}.href`],
                  )}
                >
                  <Headline6 tag="h2">
                    {intl.formatMessage(messages[`jobsAction.${action}`])}
                  </Headline6>
                  <Body2>
                    {intl.formatMessage(
                      messages[`jobsAction.${action}.subTitle`],
                    )}
                  </Body2>
                </LinkAndAnchor>
              </StyledListItem>
            </Fragment>
          ))}
      </List>
    </>
  );
};

export const JobsLandingPage = () => {
  const intl = useIntl();

  return (
    <JobsLandingContainer>
      <Head
        title={intl.formatMessage(messages.jobsTitle)}
        description={intl.formatMessage(messages.jobsMetaDescription)}
      />
      <JobsLandingTitle>
        <Title tag="h1">
          {intl.formatMessage(messages.jobsTitle)}
        </Title>
      </JobsLandingTitle>
      <JobsLandingCategories>
        <Categories />
      </JobsLandingCategories>
      <JobsLandingSidebar>
        <Actions />

        <SideBarAdUnitContainer>
          <AdUnit
            adUnit="job_landing_rectangle1"
            sizes={[[300, 250]]}
            minHeight="250px"
          />
        </SideBarAdUnitContainer>

      </JobsLandingSidebar>
      <JobsLandingTitle>
        <WfbTitle>
          { intl.formatMessage(messages.jobsWfbTitle) }
        </WfbTitle>
        <WfbAds />
      </JobsLandingTitle>
    </JobsLandingContainer>
  );
};

JobsLandingPage.getInitialProps = (context) => {
  correctLocalizedRoute(context, 'jobs-landing');
  return {};
};

export default withApollo(JobsLandingPage);
